import { render } from "./PromptsSection.vue?vue&type=template&id=9b2392f6&scoped=true"
import script from "./PromptsSection.vue?vue&type=script&lang=js"
export * from "./PromptsSection.vue?vue&type=script&lang=js"

import "./PromptsSection.vue?vue&type=style&index=0&id=9b2392f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2392f6"]])

export default __exports__